import React from "react";
import PropTypes from "prop-types";
import ModalBottom from "../ModalBottom/ModalBottom";
import DynamicRange from "../../../js/components/molecules/DynamicRange";

const ModalDynamicRange = ({
	show,
	closeModal,
	bestAverage,
	averageMiles,
	startAverage,
	endAverage,
	changeAverageSlider,
	validRange
}) => {
	return (
		<ModalBottom
			show={show}
			close={() => closeModal("forgotPassword", false)}
			fixed
			description={
				<DynamicRange
					// bonusMaxPrice={bonusMaxPrice}  // bonusMaxPrice
					bestAverage={bestAverage} // bestAverage
					// eligableAverage={eligableAverage} // eligableAverage
					// eligableQuant={eligableQuant} // eligableQuant
					// eligableColor={eligableColor} // eligableColor
					averageMiles={averageMiles} // averageMiles
					startAverage={startAverage} // startAverage
					endAverage={endAverage} // endAverage
					// bonusCssConfig={bonusCssConfig} // bonusCssConfig
					// maxEligableQuant={maxEligableQuant} // maxEligableQuant
					// minEligableQuant={minEligableQuant} // minEligableQuant
					changeAverageSlider={changeAverageSlider} // this.changeAverageSlider
					// fidelityLabel={fidelity && fidelity.label.toLowerCase()} // fidelity && fidelity.label.toLowerCase()
					// focusInputPrice={this.focusInputPrice} // this.focusInputPrice
					validRange={validRange} // reducao && reducao.value && mediasOptions
				/>
			}
			confirm="Salvar"
			onConfirm={() => closeModal("forgotPassword", false)}
			className="modal-dynamic-range"
		/>
	);
};

ModalDynamicRange.propTypes = {
	show: PropTypes.bool.isRequired,
	closeModal: PropTypes.func.isRequired
};

export default ModalDynamicRange;
